import size from "../sizes";
import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Стильные, яркие, облегающие - это всё про наши легинсы! Мягкая и приятная ткань Интерлок 270 прекрасно подходит для нанесения красочного уникального принта и сохраняет рисунок без выцветания. Нестандартный крой, схожий с идеально подогнанными спортивными моделями Adidas и Reebok. С нашими легинсами вы подчеркнете достоинства фигуры и будете чувствовать себя комфортно в любой ситуации.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`leggings`],
      sizeInfo: `leggings`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
